import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';
import { DatasourceWizardService } from '../../../services/datasource/datasource.wizard.service';
import { EntityCacheProvider } from '@nrwl/common-lib';

@Component({
  selector: 'datasource-gigatest-review-html',
  templateUrl: './datasource.gigatest.review.page.html',
  providers: [],
  styleUrls: ['../datasource.style.scss', './datasource.gigatest.review.style.scss']
})
export class DatasourceGigaTestReviewComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm') form: NgForm;

  locationName: string;
  editMode: boolean;
  host: string;
  userName: string;
  editAlias = false;
  alias: string;
  agentType: string;
  hardwareAgent = false;
  validAlias = true;
  siteId: number;
  deviceNameList = [];
  nameExist = false;
  actualTestName = '';

  constructor(
    private wizardService: DatasourceWizardService,
    private entityCache: EntityCacheProvider
  ) {}

  ngOnInit() {
    this.step.form = this.form;
    this.locationName = this.step.parent.output.locationName;
    this.editMode = this.wizardService.editMode;
    this.alias = this.step.parent.output.alias;
    this.agentType = this.step.parent.output.agentType;
    this.hardwareAgent = this.agentType === 'Hardware';
    this.siteId = this.step.parent.output.siteId;
    this.actualTestName = this.step.parent.output.alias;
    this.entityCache
      .findEntityCache('device')
      .getValuesAsync()
      .pipe()
      .subscribe(devices => {
        this.deviceNameList = devices.map(item => item.escapedName);
      });
  }

  onAliasChange(): void {
    if (this.editMode) {
      if (
        this.deviceNameList.some(item => item.toLowerCase() === this.alias.toLowerCase()) &&
        this.alias.toLowerCase() !== this.actualTestName.toLowerCase()
      ) {
        this.onDataValueChange.emit({
          componentId: this.componentId,
          inputId: 'aliasInput',
          key: 'alias',
          newValue: this.alias,
          isValid: false
        });
        this.nameExist = true;
      } else {
        this.nameExist = false;
        this.onDataValueChange.emit({
          componentId: this.componentId,
          inputId: 'aliasInput',
          key: 'alias',
          newValue: this.alias,
          isValid: false
        });
      }
    }
  }

  aliasUpdated(): void {
    this.validAlias = this.form.controls.alias.valid;
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'aliasInput',
      key: 'alias',
      newValue: this.alias,
      isValid: this.validAlias
    });
    this.editAlias = false;
  }

  makeEditAlias(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'aliasInput',
      key: 'alias',
      newValue: this.alias,
      isValid: false
    });
    this.editAlias = true;
  }
}
